import ms from "ms";

/**
 * Get TTL (Time To Live) in milliseconds from database AppSetting
 * 
 * @param key - Setting key (e.g., "NEXT_PUBLIC_SURVEY_TTL_SECONDS")
 * @returns TTL in milliseconds, defaults to 1 year if not found
 */
export const getTTL = async (key: string): Promise<number> => {
    try {
        // Get value from database AppSetting
        const { getAppSetting } = await import("@/actions/app-settings");
        const dbValue = await getAppSetting(key);
        
        if (dbValue) {
            const ttlMs = ms(dbValue as ms.StringValue);
            if (ttlMs !== undefined) {
                return ttlMs;
            }
        }
    } catch (error) {
        console.error(`❌ Failed to get TTL from database for ${key}:`, error);
    }
    
    // Default fallback: 1 year
    console.warn(`⚠️ No TTL found in database for ${key}, using default: 1y`);
    return ms('1y');
};

